import { decodeToken, getTokens, setTokens } from '@discover-frontend/auth';

import { storeTokens } from './AuthHelperMethods';

const getTokenExp = (token) => {
  const decoded = decodeToken(token);
  return decoded?.exp ?? 0;
};

/**
 * Sync Amplify / Redux tokens into HELIXA localStorage + SSO cookies.
 * Skips writes when existing local tokens are newer (avoids stale Amplify overwriting a fresh refresh).
 */
export const syncSsoTokens = ({ accessToken, idToken, refreshToken }) => {
  if (!accessToken || !idToken) return;

  const current = getTokens();
  const incomingExp = getTokenExp(accessToken);
  const currentExp = getTokenExp(current.accessToken);

  if (current.accessToken && currentExp >= incomingExp) {
    return;
  }

  setTokens(accessToken, idToken, refreshToken);
  storeTokens({ refreshToken, idToken, accessToken });
};
